import React from 'react';
import { generatePath, Link } from 'react-router-dom';

import { Routes } from '../../routes';

const LogoutLink = (): React.ReactElement => (
  <Link className="logout-link button primary" to={generatePath(Routes.Session.Destroy)}>
    Logout
  </Link>
);

export default LogoutLink;
